// src/lib/pairingCode.js
// Filepath: // src/lib/pairingCode.js
const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford (no I, L, O, U)

export function generateCode(length = 6) {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < length; i++) out += ALPHABET[bytes[i] % ALPHABET.length];
  return out; // already uppercase
}

const NORMALIZE_MAP = Object.freeze({
  i: "1", l: "1", I: "1", L: "1",
  o: "0", O: "0",
  u: "V", U: "V",
});

export function normalizeCode(input = "") {
  return input
    .trim()
    .split("")
    .map(ch => NORMALIZE_MAP[ch] ?? ch)
    .join("")
    .toLowerCase();
}

export function toDisplay(codeLower = "") {
  return codeLower.toUpperCase();
}
